/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { Resource } from '@common/application/enums/Resource';
import { ElasticResponse, ElasticSort } from '@common/types/elastic';
import { Nullable } from '@common/types/utils';

export class Audit {
  id: number;
  event: Record<string, unknown>;
  date: string;

  constructor(id: number, event: Record<string, unknown>, date: string) {
    this.id = id;
    this.event = event;
    this.date = date;
  }

  static list(query, sort, size?: number, pit?: Nullable<string>, search_after?: Nullable<ElasticSort>): ElasticResponse<Audit> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axiosInstance
        .get(`/api/v1/audits`, {
          params: {
            sequence_id: 1,
            pit,
            query,
            sort: JSON.stringify(sort),
            search_after: JSON.stringify(search_after),
            size,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static async auditSignedUrlUpload(record: Record<string, any>, path: string, resource: Resource) {
    return axiosInstance.post(`/api/v1/audits/auditupload`, { record, path, resource });
  }

  static async getAuditForSignedUrlUpload(path: string) {}
}
